<template>
  <div class="container my-account">
    <AppBreadcrumbs />

    <h1
      class="my-account__title heading heading--1"
      v-text="$t('My account')"
    />

    <div class="my-account__wrapper">
      <div class="my-account__content">
        <div class="my-account__forgot-password">
          <h2
            class="my-account__heading heading heading--2"
            v-text="$t('Forgot your password?')"
          />

          <div class="my-account__text">
            <p v-text="$t('Please enter your email address below to receive a password reset link.')" />
          </div>

          <AccountForgotPassword @success="navigateTo('/account/')" />
        </div>

        <div class="my-account__register">
          <h2
            class="my-account__heading heading heading--2"
            v-text="$t('No account yet?')"
          />

          <AccountUsps />

          <AppLink
            :to="{ name: 'register' }"
            class="button"
            :class="{ 'button--shop-flow button--full': travelbagsOnly }"
          >
            <span>{{ $t('Create a free account') }}</span>
          </AppLink>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useBreadcrumbs } from '~layers/app/composables/useBreadcrumbs.ts'

const { public: config } = useRuntimeConfig()
const { t } = useI18n({ useScope: 'global' })
const { setBreadcrumbs } = useBreadcrumbs()
setBreadcrumbs({
  label: t('Forgot password'),
  parents: [
    {
      label: t('My account'),
      url: 'account',
    },
  ],
})

const { pageView } = useDataLayer()
pageView('other', t('Register'))

const travelbagsOnly = computed(
  () => config.storeHeader.startsWith('tra'),
)

useHead({
  meta: [
    { name: 'robots', content: 'noindex, follow' },
  ],
})
</script>

<style>
@import url("~layers/app/pages/account.css");
</style>
